import * as React from 'react'
import { Typography } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'

const { Text } = Typography

interface ComingSoonProps {
  title: string
  description: string
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
  return (
    <div
      style={{
        border: '1px solid #f0f0f0',
        borderRadius: 8,
        padding: '48px 24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
      }}>
      <ClockCircleOutlined style={{ fontSize: 32, color: '#BFBFBF' }} />
      <Text strong>{title}</Text>
      <Text type='secondary' style={{ textAlign: 'center' }}>
        {description}
      </Text>
    </div>
  )
}
